var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNavigationHeart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 45,
    viewBox: "0 0 45 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.5 10.7081C23.7919 9.19687 26.0269 7.5 29.43 7.5C35.3831 7.5 39.375 13.0875 39.375 18.2906C39.375 29.1675 25.8337 37.5 22.5 37.5C19.1663 37.5 5.625 29.1675 5.625 18.2906C5.625 13.0875 9.61687 7.5 15.57 7.5C18.9731 7.5 21.2081 9.19687 22.5 10.7081Z",
    stroke: "currentColor",
    strokeWidth: "inherit",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavigationHeart);
export default __webpack_public_path__ + "static/media/navigation-heart.a2681697.svg";
export { ForwardRef as ReactComponent };